export interface IPlayer {
  id: number;
  user_id: number;
  name: string;
  avatar_url: string;
  score: number;
  best_score: number;
  position: number;
  display_position: number;
  cash_prize: number;
  getz_prize: number;
  ticketz_prize: number;
  custom_prize: {
    id: number;
    name: string;
    description: string;
    estimated_value: number;
    position: number;
    image_url: string;
    formatted_result_description: string;
    type: string;
  };
  shoutout: string;
  entry_id: string;
  state: string;
  flag_url: string;
  thumbnail_url: string;
  replay_url: string;
  is_staff: boolean;
  ticketz_won_prize: number;
  bonus_cash_prize: number;
  experience_gained: number;
  is_bot: boolean;
  outcome: string;
  finished_at: string;
  playing_now: boolean;
  show_report_problem: boolean;
}

export interface ITurn {
  id: string;
  round: number;
  score: number;
  opponentScore: number;
  outcome: string;
  state: string;
  expires_at: string;
  started_at: string;
  ended_at: string;
  game_data: {
    version: number;
    date_created: string;
    game_data: string;
    last_updated: string;
    tournament_id: number;
    tournament_turn_id: number;
  };
}

export interface IRandomNumberStrategy {
  id: number;
  version: number;
  date_created: string;
  last_updated: string;
  tie_breaker_tournament_id: number;
  tied_tournament_id: number;
}

export interface IBracket {
  id: string;
  position: number;
  expires_at: string;
  state: string;
}

export interface IShare {
  url: string;
  subject: string;
  message: string;
  replayUrl: string;
}

export interface IScoreMessages {
  your: string;
  best: string;
  last_entry: string;
  in_progress: string;
}

export interface IRule {
  name: string;
  value: string;
}

export interface IMatch {
  id: number;
  name: string;
  tournament_id: number;
  started_at: string;
  finished_at: string;
  expires_at: string;
  category: string;
  type: string;
  can_challenge_rematch: boolean;
  num_players: number;
  players: IPlayer[];
  turns: ITurn[];
  last_turn_ended_at: string;
  share: IShare;
  record_replay: boolean;
  random_number_seed: number;
  random_number_seeds: number[];
  random_number_strategy: string;
  rules: IRule[];
  score_messages: IScoreMessages;
  cash_fee: number;
  z_fee: number;
  bracket: IBracket;
  previous_ties: string[];
  tie_breaker: boolean;
  next_tie_breaker: IRandomNumberStrategy;
  entries_remaining: number;
  location_required: boolean;
  connect_token: string;
  staff_refund: boolean;
  match_code: string;
  custom_color: string;
  hosted_tournament_logo: string;
  brand_logo: string;
  formatted_participation_message: string;
  skillz_powered_image_url: string;
  welcome_back_override_theme_type: string;
  welcome_back_override: boolean;
  results_share_message: string;
  is_rematch: boolean;
}

// https://docs.skillz.com/docs/api-reference/#player
export interface ISdkPlayer {
  id: number;
  displayName: string;
  avatarURL: string;
  flagURL: string;
  isCurrentPlayer: boolean;
  playerMatchId: number;
}

export enum MatchState {
  'FINISHED' = 'FINISHED',
  'ABORTED' = 'ABORTED',
  'PENDING' = 'PENDING',
}

// https://docs.skillz.com/docs/api-reference/#match
export interface ISdkMatch {
  // Todo redfine when working on sync match joins
  connectionInfo?: Record<string, string>;
  matchDescription: string;
  entryCash: number;
  entryPoints: number;
  id: number;
  playerMatchId?: number;
  templateId: number;
  name: string;
  gameParameters: Record<string, string>;
  isCash: boolean;
  isSynchronous: boolean;
  isTieBreaker: boolean;
  isBracket: boolean;
  bracketRound: number;
  isVideoAdEntry: boolean;
  players: Array<ISdkPlayer>;
}
